<template>
    <div class="card flex-container my-4">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Fotos' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />
        </div>
        <div v-if="!resumo">
            <h4 class="mb-2">Por favor, inclua as imagens do veículo. Siga as etapas para adicionar:</h4>
            <div  class="flex flex-wrap gap-2 items-start justify-evenlly mb-4">
                <div v-for="tipo in tiposFotos" :key="tipo.id" :class="tipo.imagemUpload == '' || tipo.imagemUpload == NULL ? 'botao-foto-upload' : ''">
                    <div role="button" v-if="tipo.imagemUpload == '' || tipo.imagemUpload == NULL" @click="tirarFoto(identificadorRota, localRealizacao, modulo, etapaComponente, idComponente, tipo.label, tipo.id)">
                        <div class="flex flex-col justify-center items-center">
                            <img class="w-12 h-12 cursor-pointer" :src="tipo.imagem" alt="Câmera">
                            <span class="w-full cursor-pointer text-center mt-1">{{ tipo.label }}</span>
                        </div>
                    </div>
                    <div v-else class="foto-carregada h-24" :id="tipo.id" @mouseenter="controlaClasseElemento" @mouseleave="controlaClasseElemento">
                        <div class="flex flex-col items-center">
                            <img class="w-28 h-20 " :src="tipo.imagemUpload" alt="Foto">
                            <div class="cursor-pointer text-xs">{{ tipo.label }}</div>
                        </div>
                        <div class="material-symbols-outlined text-white bg-vermelho-padrao cursor-pointer w-full mt-2 text-center"
                            @click="excluirFoto(tipo.idArquivoChecklistModular, tipo.id)">
                            delete
                        </div>
                    </div>
                </div>
                <div v-for="outra in outrasFotos" :key="outra.tipo" :id="outra.id" class="foto-carregada h-24"
                    @mouseenter="controlaClasseElemento" @mouseleave="controlaClasseElemento">
                    <div class="flex flex-col items-center">
                        <img class="w-28 h-20 " :src="outra.imagem" alt="Foto">
                        <span class="cursor-pointer text-xs">{{ outra.observacao || outra.label }}</span>
                    </div>
                    <div class="material-symbols-outlined text-white bg-vermelho-padrao cursor-pointer w-full mt-2 text-center"
                        @click="excluirFoto(outra.idArquivoChecklistModular, outra.id)">
                        delete
                    </div>
                </div>
                <div class="flex items-center justify-center w-28 h-24 text-azul-info">
                    <div role="button" @click="tirarFoto(identificadorRota, localRealizacao, modulo, etapaComponente, idComponente, 'Outras', 'Outras')">
                        <div class="flex flex-col justify-center items-center">
                            <span class="material-symbols-outlined">add_a_photo</span>
                            <span class="w-full cursor-pointer text-center mt-1">Outras</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <FotoResumo :tiposFotos="tiposFotos" :outrasFotos="outrasFotos" />
        </div>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import Actions from '@/store/Actions'
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import FotoResumo from '@/common/foto/components/FotoResumo.vue';
import Status from '@/components/Status.vue';
import ComponentesService from '@/services/ComponentesService';
import ComponenteFotoService from '@/services/componentes/ComponenteFotoService';
import FuncoesHelper from '@/helpers/FuncoesHelper';

/* eslint-disable vue/no-setup-props-destructure */
export default defineComponent({
    name: 'Foto',
    components: {
        FotoResumo,
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    methods: {
        async tirarFoto(identificadorRota, localRealizacao, modulo, etapa, idComponente, tipo, id) {
            if(FuncoesHelper.validarChecklistPreview()) {
				return;
			}

            if(!await FuncoesHelper.verificarPermissaoCamera()) {
                FuncoesHelper.notificar("error", "Erro ao acessar a câmera.", "Permissão de câmera não concedida", 15000);
                return;
            }

            await new Promise(resolve => setTimeout(resolve, 500));
            this.$router.push({
                name: 'TirarFoto',
                params: { identificadorRota, localRealizacao, modulo, etapa, idComponente },
                query: { tipo, id }
            });
        },
        excluirFoto(idArquivoChecklistModular, idFoto) {
            if(FuncoesHelper.validarChecklistPreview()) {
                    return;
			}
            this.$confirm("Tem certeza que deseja excluir a foto?", "", "question", {
                confirmButtonText: "Sim",
                cancelButtonText: "Não"
            }).then(() => {
                const foto = {
                    idArquivoChecklistModular: idArquivoChecklistModular,
                    idArquivo: idFoto
                }

                this.$store.dispatch(Actions.EXCLUIR_FOTO, {
                    modulo: this.modulo,
                    etapa: this.etapaComponente,
                    idComponente: this.idComponente,
                    foto
                }).then(() => {
                    const indexOutraFoto = this.outrasFotos.findIndex(outraFoto => outraFoto.idArquivoChecklistModular === idArquivoChecklistModular);
                    if (indexOutraFoto !== -1) {
                        this.outrasFotos.splice(indexOutraFoto, 1);
                    }

                    const tipoFotoComImagem = Object.values(this.tiposFotos).find(tipoFoto => tipoFoto.idArquivoChecklistModular === idArquivoChecklistModular);
                    if (tipoFotoComImagem) {
                        tipoFotoComImagem.imagemUpload = '';
                        delete tipoFotoComImagem.idArquivoChecklistModular;
                    }

                    this.fotoExcluir.idArquivoChecklistModular = ''

                    const respostaAlterada = Object.values(this.tiposFotos).every(tipoFoto => tipoFoto.idArquivoChecklistModular)
                    this.statusResposta = ref(ComponentesService.validaStatusRespostaComponente(this.respostaObrigatoria, respostaAlterada))
                }).catch(() => {
                    FuncoesHelper.notificar('error', 'Erro', 'Erro ao excluir foto')
                })                  
            }, () => {});

            
        },
        controlaClasseElemento(e) {
            e.target.classList.toggle('h-32')
        },
    },
    setup(props) {
        return ComponenteFotoService.setup(props)
    }
});
</script>